import * as React from 'react';
import { actionCreators } from './actions';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux/index';
import { myNotificationsTranslations } from './constants';
import { MyNotificationsContainerProps } from './types';
import { ElementLoader, Paper } from 'ui';
import { withSimpleForm, simpleFieldForPath } from 'app/infrastructure/simple-form';
import { ConsentList } from './consent-list';
import { TopPanel } from 'app/area/user-profile/my-notifications/top-panel';
import { InfoMessages } from './info-messages';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';
import { UserProfileHeading } from 'app/area/user-profile/user-profile-heading';

import styles from './my-notifications.scss';
import { UserProfileSectionHeading } from 'app/area/user-profile/user-profile-section-heading';

const SimpleForm = simpleFieldForPath(STATE.myNotifications);

export class MyNotificationsComponent extends React.Component<MyNotificationsContainerProps, {}> {
  public static statePath: string = STATE.myNotifications;

  public componentDidMount() {
    this.props.loadPermission();
    this.loadConsents();
  }

  private loadConsents = () => {
    const { loadConsents, sharedState: { id: recipientId } } = this.props;
    recipientId && loadConsents(recipientId);
  }

  public render() {
    const { consents, fetchingLoadConsents, sharedState: { id: recipientId }, translation } = this.props;

    return (<Paper componentId="my-notifications-paper" className="">
      <UserProfileHeading title={translation.main_title} />
      <UserProfileSectionHeading sectionTitle={translation.sub_title} disclaimer={translation.consents_disclaimer} />
      <section>
        <div className="main-grid">
          <InfoMessages consents={consents} translation={translation} />
          <div className={styles.consentsContainer}>
            <TopPanel
              {...this.props}
              recipientId={recipientId}
              formComponent={SimpleForm}
              loadData={this.loadConsents} />
            <div className="row expanders-in-equal-cols">
              <div className="col-md-12">
                {fetchingLoadConsents
                  ? <ElementLoader />
                  : <ConsentList
                    {...this.props}
                    formComponent={SimpleForm}
                    loadConsents={this.loadConsents} />}
              </div>
            </div>
          </div>
        </div>
      </section>

      <ScrollToTop />
    </Paper>);
  }
}

const container = withSimpleForm(containerFactory(MyNotificationsComponent, actionCreators, {}, myNotificationsTranslations));

export { container as MyNotifications };
